<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string;
    disabled?: boolean;
    buttonStyles?: string;
    isLoading?: boolean;
    tooltip?: string;
  }>(),
  {
    title: "",
    disabled: false,
    isLoading: false,
  },
);

const emit = defineEmits<{ click: [payload: MouseEvent] }>();
</script>

<template>
  <button
    class="flex flex-row justify-center items-center gap-2 p-2 px-3 font-bold text-white rounded-xl border border-gray-300"
    :class="
      disabled || isLoading
        ? 'bg-light-gray cursor-not-allowed'
        : 'bg-primary hover:brightness-[1.05] ' + buttonStyles
    "
    @click="emit('click', $event)"
    :disabled="disabled || isLoading"
    :title="tooltip"
  >
    <slot></slot>
    {{ title }}
    <span
      v-if="isLoading"
      class="h-4 w-4 border-2 border-white/40 border-t-white rounded-full animate-spin"
    ></span>
  </button>
</template>
